import { C as State } from "../../state/State";
import { paths } from "./routerPaths";
import { Routes } from "./routerRoutes";
import { updateUrlWithPushState } from "./updateUrlWithPushState";

export const updateUrl = (state: State<Routes>) => 
    updateUrlWithPushState(paths, state, window.history.pushState.bind(window.history))
;
